module.exports = __webpack_public_path__ + "img/usuario.b5de48c3.jpg";